import React, { Component } from 'react'
import ContentHeader from '../../components/ContentHeader'
import ImageViewer from '../../components/ImageViewer'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
    getPhotos,
    deletePhoto,
    uploadPhotos,
    saveOrder
} from '../../modules/photos'
import '../../styles/css/photography.css'
import Reorder from 'react-reorder'

class Photography extends Component {

    constructor(props) {
        super(props)
        this.state = {
            viewer: false,
            image: 0
        }
    }

    componentDidMount = () => {
        this.props.getPhotos()
    }
    
    showViewer = index => {
        document.body.style.overflow = "hidden"
        this.setState({
            viewer: true,
            image: index
        })
    }

    callback = (event, itemThatHasBeenMoved, itemsPreviousIndex, itemsNewIndex, reorderedArray) => {
        let newArray = []
        reorderedArray.map((item,index) => {
          item.order = index
          newArray.push(item)
        })
        this.props.saveOrder(newArray)
    }

    cancelViewer = () => {
        document.body.removeAttribute("style")
        this.setState({
            viewer: false
        })
    }
    
    Photo = ({ item }) => {
        return (
            <div className="photo">
                {item.files && <div className="photo-image" style={{backgroundImage: `url('${item.images.small}')`}}></div>}
                <button onClick={() => this.props.deletePhoto(item._id)}>Delete</button>
            </div>
        )
    }

    itemClicked = (event, itemThatHasBeenClicked, itemsIndex) => {
        this.showViewer(itemsIndex)
    }

    render() {
        const { uploading } = this.props
        let { photos } = this.props
        const { deletePhoto, uploadPhotos } = this.props
        photos.sort(function(a, b){return a.order - b.order})
        return(
            <div id="content">
                <ContentHeader title="Photography">                    
                    <label className="upload-photos">
                        <input type="file" accept="image/*" onChange={uploadPhotos} required multiple/>
                        <span>
                            {uploading && <div className="loader"></div>}
                            {uploading ? 'Uploading photos..' : 'Upload photos'}
                        </span>
                    </label>           
                </ContentHeader>

                {this.state.viewer && <ImageViewer images={photos} currentImage={this.state.image} onCancel={this.cancelViewer} />}

                <div id="content-body">
                        <Reorder
                            itemKey='_id'
                            holdTime='200'
                            list={photos}
                            template={this.Photo}
                            callback={this.callback}
                            listClass='photography'
                            itemClass='photo-image'
                            itemClicked={this.itemClicked}
                            selectedKey='uuid'
                            disableReorder={false}
                        />
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ photos: { photos,uploading } }) => ({
    photos,
    uploading
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getPhotos,
    deletePhoto,
    uploadPhotos,
    saveOrder
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Photography)


// WEBPACK FOOTER //
// ./src/containers/photography/index.js